module.exports = __webpack_public_path__ + "static/media/video_consent_audio_urdu.612d3189.mp3";